<template>
  <dialog-email
    :isLoading="isLoading"
    :contentKey="contentKey"
    :contentMap="contentMap"
    ref="dialogEmail"
    :data="data"
    @on-submit-email="onSubmitEmail"
  >
  </dialog-email>
</template>

<script>
import { ServiceQi } from '@/services/qi'
import { ServiceEmailMessages } from '@/services/email-messages'

const DEFAULT_EMAIL_LIST = [
  'logistics@bel-airexpress.com',
  'purchasing@bel-airexpress.com',
  'support@bel-airexpress.com'
]

export default {
  name: 'SendEmailWrap',
  components: {
    'dialog-email': () => import(/* webpackChunkName: 'Dialog' */ '@/components/Dialogs/DialogEmail/index')
  },
  props: {
    qiID: { required: true }
  },
  data () {
    return {
      isLoading: false,
      data: {},
      contentMap: {},
      logoType: 0
    }
  },
  computed: {
    contentKey () {
      return 'qi-send-email'
    }
  },
  methods: {
    onSubmitEmail (data) {
      return this.sendEmail(data)
    },
    async sendEmail (emailData) {
      this.isLoading = true
      const id = this.qiID
      const logoKey = this.logoType

      try {
        await ServiceEmailMessages
          .sendQi({ id, logoKey, translate: this.L10n, ...emailData })
        this.requestSuccessHandler()
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
        this.hide()
      }
    },
    show ({ logoType }) {
      this.logoType = logoType
      this.$refs.dialogEmail.show()
      this.loadData()
        .then((data) => {
          data = data || {}
          this.contentMap = {
            partNumber: data.partNumber,
            partSN: data.partSN,
            condition: data.condition,
            remark: data.remark
          }
          this.data = {
            ...data,
            body: [
              `Attached Quality Inspections for P/N: ${data.partNumber}, S/N: ${data.partSN}`,
              data.condition,
              data.remark
            ].filter(Boolean).join('</br>'),
            subject: `Quality Inspections for P/N: ${data.partNumber}, S/N: ${data.partSN}`,
            emailToList: [...DEFAULT_EMAIL_LIST]
          }
        })
        .catch((err) => {
          this.requestErrorHandler(err)
        })
    },
    hide () {
      this.logoType = 0
      this.$refs.dialogEmail.hide()
    },
    async loadData () {
      this.isLoading = true
      try {
        const { data } = await ServiceQi.getDynamic(this.qiID, {
          select: [
            'id', 'part.partNumber as partNumber', 'partSN',
            'condition.title as condition', 'remark'
          ].join(',')
        })
        return data
      } catch (e) {
        throw e
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
